import React, { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import { WhiteTooltip } from 'components/Ui/styled';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyButton = ({ text, size = 'small', stopPropagation }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }

    navigator.clipboard.writeText(text);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <WhiteTooltip title={copied ? 'Copied!' : 'Copy'}>
      <IconButton size={size} className="copy-btn" onClick={handleCopy}>
        {copied ? (
          <CheckIcon sx={{ fontSize: 16 }} />
        ) : (
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        )}
      </IconButton>
    </WhiteTooltip>
  );
};

export default CopyButton;
